import React from 'react';
import PropTypes from 'prop-types';

// Outline paper-plane share glyph; the icomoon set only carries solid
// send/plane variants, so the vector is inlined here.
const SharePlaneIcon = ({ size, color }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 19.9883 19.9693'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.928 0.741314V0.651314C19.8801 0.540022 19.8123 0.43837 19.728 0.351314C19.6432 0.271579 19.545 0.207279 19.438 0.161314H19.348C19.2559 0.0909241 19.1504 0.039901 19.038 0.011314H18.988C18.8886 -0.00377132 18.7875 -0.00377132 18.688 0.011314L0.688021 6.01131C0.16335 6.18376 -0.12218 6.74889 0.0502708 7.27356C0.149475 7.57539 0.386199 7.81211 0.688021 7.91131L9.21802 10.7513L12.058 19.2813C12.2305 19.806 12.7956 20.0915 13.3203 19.9191C13.6221 19.8199 13.8588 19.5831 13.958 19.2813L19.958 1.28131C19.9803 1.1931 19.9903 1.10226 19.988 1.01131C19.9776 0.919449 19.9575 0.828945 19.928 0.741314ZM15.288 3.30131L9.71802 8.87131L4.14802 7.01131L15.288 3.30131ZM12.988 15.8513L11.128 10.2813L16.698 4.71131L12.988 15.8513Z'
      fill={color}
    />
  </svg>
);

SharePlaneIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

SharePlaneIcon.defaultProps = {
  size: 16,
  color: '#1A1A1A',
};

export default SharePlaneIcon;
